import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';

import { RootMenuComponent } from './root-menu.component';

/**
 * Thin indirection in front of the single app-wide RootMenuComponent instance.
 *
 * Any component that needs to drive the root menu (setting items, toggling it open)
 * should inject this service instead of reaching for RootComponent directly.
 * RootComponent sits at the top of the app and transitively imports large parts of it
 * (services, dialogs, etc.); injecting it from a low-level widget like MenuComponent
 * risks circular imports (see issue #612). Because this service is `providedIn: 'root'`,
 * it's available anywhere in the injector tree without pulling in RootComponent's module
 * graph, and it safely no-ops if RootMenuComponent hasn't registered yet (e.g. in
 * Storybook, where the app shell isn't mounted).
 */
@Injectable({ providedIn: 'root' })
export class RootMenuService {
  private menu?: RootMenuComponent;

  register(menu: RootMenuComponent): void {
    this.menu = menu;
  }

  setMenuItems(menuItems: MenuItem[]): void {
    this.menu?.setMenuItems(menuItems);
  }

  toggleMenu(menuItems: MenuItem[], event: Event): void {
    this.menu?.toggleMenu(menuItems, event);
  }
}
